/**
 * Feature-detects the Web MIDI API. Gameplay requires `navigator.requestMIDIAccess`
 * (used in midi-input.service.ts), which Safari, Firefox and all iOS browsers
 * lack — so the app is blocked at entry on those browsers (#410).
 */
export function isWebMidiSupported(): boolean {
  return (
    typeof navigator !== 'undefined' &&
    typeof (navigator as Navigator & { requestMIDIAccess?: unknown }).requestMIDIAccess ===
      'function'
  );
}
